<app-question-card>
  <div question>
    <p *ngIf="journeyType === FelloOfferJourneyType.IO; else Lwf">Is there anything else you want us to know about the home?</p>
    <ng-template #Lwf>
      <p>Is there anything else you want us to know about your home so that we match you with agents based on your preferences.</p>
    </ng-template>
  </div>
  <form #remarksForm="ngForm" class="h-100" input-options>
    <div class="form-field h-100 pb-2">
      <textarea
        [(ngModel)]="homeRemarks"
        class="h-100"
        name="remarks"
        placeholder="This could include any unique features, recent updates, or neighborhood highlights. If you have any photos of the home available, please include a link to them so we can better understand its layout and showcase its features to potential buyers."
        [maxlength]="2500"
      ></textarea>
    </div>
  </form>
  <p class="chat-answer text-capitalize" answer>{{homeRemarks}}</p>
  <button class="w-100" footer (click)="next()" [disabled]="remarksForm.invalid">Continue</button>
</app-question-card>
